import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "timerFormat",
  standalone: false,
})
export class TimerFormatPipe implements PipeTransform {
  transform(value: number, format: string): string {
    if (value > 0) {
      let days = Math.floor(value / (24 * 3600));
      let hours = Math.floor((value - days * 24 * 3600) / 3600);
      let minutes = Math.floor((value - (days * 24 * 3600 + hours * 3600)) / 60);
      let seconds = value - (days * 24 * 3600 + hours * 3600 + minutes * 60);

      if (!format || format === "basic") {
        return (
          (days > 0 ? days + "d " : "") +
          hours +
          ":" +
          (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
        );
      } else if (format === "extended") {
        return (
          (days > 0 ? days + " days  " : "") +
          (hours > 0 ? hours + (hours === 1 ? " hour  " : " hours  ") : "") +
          (minutes > 0 ? minutes + (minutes === 1 ? " minute  " : " minutes  ") : "") +
          seconds +
          (seconds === 1 ? " second" : " seconds")
        );
      } else if (format === "notification") {
        return (
          (days > 0 ? days + " d " : "") +
          (hours > 0 ? hours + " h " : "") +
          (minutes > 0 ? minutes + " min " : "") +
          (days < 1 && hours < 1 && minutes < 1 ? seconds + " sec" : "")
        );
      }
    } else if (value == 0 && format === "notification") {
      return "start";
    } else {
      return "expired";
    }
  }
}
